import { render, staticRenderFns } from "./OnOff.vue?vue&type=template&id=3cbdd5ce&scoped=true&"
import script from "./OnOff.vue?vue&type=script&lang=js&"
export * from "./OnOff.vue?vue&type=script&lang=js&"
import style0 from "./OnOff.vue?vue&type=style&index=0&id=3cbdd5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbdd5ce",
  null
  
)

component.options.__file = "OnOff.vue"
export default component.exports